import { ca } from '@cian/analytics';

import { getSurveyAnalyticsParams } from './getSurveyAnalyticsParams';
import { IMakeHandlerParams } from './types';

export function makeSurveyAnalyticsHandler(params: IMakeHandlerParams) {
  const category = 'Offer_analytics';

  const preparedParams = getSurveyAnalyticsParams({
    ...params,
    category,
  });

  return (action: string, label: string) => {
    const updatedParams = {
      ...preparedParams,
      action,
      label,
    };

    ca('eventSite', updatedParams);
  };
}
